import { Theme } from '@mui/material/styles'

const muiAppBar = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        // background: theme.colors.hydrationLight,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        borderBottom: `1px solid ${theme.colors.stroke}`,
        toolbar: {
          root: {
            minHeight: 56,
            paddingLeft: 60
          }
        }
      }
    }
  }
}

export default muiAppBar
